import React from 'react';
import AdvancedAutocompleteDictionary from './advancedAutocomplete';
import {AutocompleteDictionary} from './autocomplete';
import {getEcdsVersion} from '../../store/reducers/dicts';
import {useDispatch} from 'react-redux';

// Diagnosis
function ControlDiagnosis(props) {
    const dispatch = useDispatch();

    // ECDS version
    const version = dispatch(getEcdsVersion(props.admitDate));
    const ecdsVersionFilter = encodeURIComponent(`ecdsVersion eq '${version}' and deactivated ne true`);

    const getDictionaryURL = filter => {
        if (props.showAll) {
            return `/$dict/EcdsDiagnosis?$filter=${ecdsVersionFilter}&$sort=sort1,sort2,sort3,sort4`;
        }
        let filterText = '';
        if (filter) filterText = ` and (${encodeURIComponent(filter)})`;
        return `/$dict/EcdsDiagnosis?$filter=((${ecdsVersionFilter})${filterText})&$sort=sort1,sort2,sort3,sort4`;
    };

    return (
        <AdvancedAutocompleteDictionary
            type="Diagnosis"
            multiple
            renderText="snomedDescription"
            multiSearchColumnName={['searchTerms', 'description', 'snomedDescription']}
            groupBy={opt => opt.group2}
            dictionaryURL={getDictionaryURL}
            extended
            ecdsVersion={version}
            {...props}
        />
    );
}

// Single choice Diagnosis
function ControlDiagnosisSimple(props) {
    const dispatch = useDispatch();

    // ECDS version
    const version = dispatch(getEcdsVersion(props.admitDate));
    const ecdsVersionFilter = encodeURIComponent(`ecdsVersion eq '${version}' and deactivated ne true`);
    const getDictionaryURL = filter => {
        let filterText = '';
        if (filter) filterText = ` and (${encodeURIComponent(filter)})`;
        return `/$dict/EcdsDiagnosis?$filter=((${ecdsVersionFilter})${filterText})&$sort=sort1,sort2,sort3,sort4`;
    }

    return (
        <AutocompleteDictionary
            renderText="snomedDescription"
            multiple
            multiSearchColumnName={['searchTerms', 'description', 'snomedDescription']}
            groupBy={opt => opt.group2}
            dictionaryURL={getDictionaryURL}
            dontTrimSearch
            {...props}
        />);
}

// Treatment
function ControlTreatment(props) {
    const dispatch = useDispatch();

    // ECDS version
    const version = dispatch(getEcdsVersion(props.admitDate));
    const ecdsVersionFilter = encodeURIComponent(`ecdsVersion eq '${version}' and deactivated ne true`);

    const [grouping, setGrouping] = React.useState(!props.showIndicatedFlag);

    const getDictionaryURL = (filter) => {
        if (props.showIndicatedFlag) {
            let newFilter = `(${props.showIndicatedFlag} eq true)`;
            if (filter !== '') {
                setGrouping(true);
                newFilter = filter;
            } else {
                setGrouping(false);
            }
            return `/$dict/EcdsTreatments?$filter=((${ecdsVersionFilter}) and (${encodeURIComponent(newFilter)}))&$sort=sort1,sort2,sort3,sort4`;
        }
        let filterText = '';
        if (filter) filterText = ` and (${encodeURIComponent(filter)})`;
        return `/$dict/EcdsTreatments?$filter=((${ecdsVersionFilter})${filterText})&$sort=sort1,sort2,sort3,sort4`;
    };

    return (
        <AdvancedAutocompleteDictionary
            type="Treatment"
            multiple
            multiSearchColumnName={['searchTerms', 'description']}
            groupBy={grouping ? opt => opt.group : null}
            dictionaryURL={getDictionaryURL}
            extended
            {...props}
        />
    );
}

// Rapid Assessment
function ControlRapidAssessment(props) {
    const getDictionaryURL = (filter) => {
        return `/$dict/RapidAssessment?$filter=${encodeURIComponent(filter)}`;
    };

    return <AutocompleteDictionary
        getOptionLabel={option => option.__description}
        isOptionEqualToValue={(option, value) => option.__id === value.__id}
        searchColumnName={'description'}
        dictionaryURL={getDictionaryURL}
        showAll
        {...props}
    />;

}

// Investigations
function ControlInvestigations(props) {
    const dispatch = useDispatch();

    // ECDS version
    const version = dispatch(getEcdsVersion(props.admitDate));
    const ecdsVersionFilter = encodeURIComponent(`ecdsVersion eq '${version}' and deactivated ne true`);

    const [grouping, setGrouping] = React.useState(!props.showIndicatedFlag);

    const getDictionaryURL = (filter) => {
        if (props.showIndicatedFlag) {
            let newFilter = `(${props.showIndicatedFlag} eq true)`;
            if (filter !== '') {
                setGrouping(true);
                newFilter = filter;
            } else {
                setGrouping(false);
            }
            return `/$dict/EcdsInvestigations?$filter=((${ecdsVersionFilter}) and (${encodeURIComponent(newFilter)}))&$sort=sort1,sort2,sort3,sort4`;
        }
        let filterText = '';
        if (filter) filterText = ` and (${encodeURIComponent(filter)})`;
        return `/$dict/EcdsInvestigations?$filter=((${ecdsVersionFilter})${filterText})&$sort=sort1,sort2,sort3,sort4`;
    };

    return (
        <AdvancedAutocompleteDictionary
            type="Investigation"
            multiple
            multiSearchColumnName={['searchTerms', 'description']}
            groupBy={grouping ? opt => opt.group : null}
            dictionaryURL={getDictionaryURL}
            extended
            {...props}
        />
    );
}

export {
    ControlDiagnosis,
    ControlDiagnosisSimple,
    ControlRapidAssessment,
    ControlTreatment,
    ControlInvestigations,
};
